import { render, staticRenderFns } from "./SubFormAfcHosp.vue?vue&type=template&id=26dde53c&"
import script from "./SubFormAfcHosp.vue?vue&type=script&lang=js&"
export * from "./SubFormAfcHosp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports